var CoverageApp = new (Backbone.Router.extend({
    Models: {},
    Views: {},
    Collections: {},
    Variables: {},
    Templates: {},

    routes: {
        "resources/coverage-check-tool": "startCoverageUploadPage"
    },

    startCoverageUploadPage: function() {
        console.log("THIS IS REG");
        // Initialize the model for the CSV data
        var csvUpload = new CoverageApp.Models.Coverage();
        
        // Initialize the view and pass the model
        new CoverageApp.Views.CoverageView({ 
            model: csvUpload 
        });
    }
}));
